import React, { useMemo, useState } from 'react';
import { countedHours, isColisPriveSchedule } from '@/utils/salaryHours';

const STATUS = { prevu: 'Prévu', present: 'Présent', absent: 'Absent', repos: 'Repos', repos_force: 'Repos forcé',
  repos_demande: 'Repos demandé', cp: 'Congé payé', am: 'Arrêt maladie', formation_binome: 'Formation binôme',
  en_cours_integration: "En cours d'intégration" };
const VALID = { approved: 'Validée', validated: 'Validée', rejected: 'Refusée', pending: 'En attente', correction_requested: 'Correction demandée' };
export const fmtH = (h) => { const m = Math.round(h * 60); return `${Math.floor(m / 60)}h${String(m % 60).padStart(2, '0')}`; };
const day = (d) => new Date(`${d}T12:00:00`).toLocaleDateString('fr-FR');

function totals(rows) {
  const t = { days: rows.length, missions: 0, validated: 0, hours: 0 };
  rows.forEach((r) => {
    if (r.status === 'present' || r.status === 'prevu') t.missions += 1;
    const h = countedHours(r);
    if (h > 0) t.validated += 1;
    t.hours += h;
  });
  return t;
}

const Totals = ({ t, testid }) => (
  <span className="text-xs text-slate-700" data-testid={testid}>
    {t.days} j · {t.missions} mission(s) · {t.validated} validée(s) · <b>{fmtH(t.hours)}</b>
  </span>
);

export const HistoryEmployeeCard = ({ employee }) => {
  const [open, setOpen] = useState(false);
  const all = useMemo(() => employee.totals || totals(employee.rows), [employee.totals, employee.rows]);
  const months = useMemo(() => {
    const m = {};
    employee.rows.forEach((r) => { (m[r.date.slice(0, 7)] = m[r.date.slice(0, 7)] || []).push(r); });
    return Object.entries(m).sort((a, b) => b[0].localeCompare(a[0]));
  }, [employee.rows]);
  return (
    <div className="rounded-lg border bg-white p-4" data-testid={`history-employee-${employee.user_id}`}>
      <button type="button" className="flex w-full flex-wrap items-center gap-3 text-left" onClick={() => setOpen(!open)} data-testid={`history-toggle-${employee.user_id}`}>
        <span className="font-semibold">{employee.name || employee.email || employee.user_id}</span>
        <span className="text-xs text-slate-500">{employee.email}</span>
        <span className="rounded bg-slate-200 px-2 text-xs" data-testid={`history-deactivated-${employee.user_id}`}>
          désactivé{employee.deactivation_date ? ` le ${day(employee.deactivation_date)}` : ''}
        </span>
        <span className="ml-auto"><Totals t={all} testid={`history-total-${employee.user_id}`} /></span>
      </button>
      {open && months.map(([month, rows]) => (
        <div key={month} className="mt-3" data-testid={`history-month-${employee.user_id}-${month}`}>
          <div className="flex items-center gap-2 border-b pb-1 text-sm font-medium">
            {new Date(`${month}-15T12:00:00`).toLocaleDateString('fr-FR', { month: 'long', year: 'numeric' })}
            <span className="ml-auto"><Totals t={totals(rows)} testid={`history-month-total-${employee.user_id}-${month}`} /></span>
          </div>
          <table className="mt-1 w-full text-xs">
            <thead><tr className="text-left text-slate-500"><th>Date</th><th>Client / site</th><th>Mission</th><th>Horaires</th><th>Statut</th><th>Validation</th><th className="text-right">Heures</th></tr></thead>
            <tbody>
              {rows.map((r) => (
                <tr key={r.schedule_id || r.date} className="border-t">
                  <td>{day(r.date)}</td>
                  <td>{isColisPriveSchedule(r) ? 'Colis Privé' : 'Amazon'} · {r.site_name || '—'}</td>
                  <td>{r.tour_type || '—'}{r.vehicle_plate ? ` · ${r.vehicle_plate}` : ''}</td>
                  <td>{r.start_time || '—'}{r.end_time ? ` → ${r.end_time}` : ''}</td>
                  <td>{STATUS[r.status] || r.status || '—'}</td>
                  <td>{VALID[r.validation_status] || '—'}{r.validated_by_name ? ` (${r.validated_by_name})` : ''}</td>
                  <td className="text-right">{fmtH(countedHours(r))}{r.manual_hours != null ? ' (manuel)' : ''}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      ))}
    </div>
  );
};
